import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { whatsappCampaignInvitations } from '~/config/routes';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';
import Settings from './Settings';
import Invitations from './Invitations';
import { WhatsappInvitationProvider } from './context';

function WhatsappCampaign() {
  return (
    <WhatsappInvitationProvider>
      <Switch>
        <Route
          exact
          path={whatsappCampaignInvitations.spec}
          render={(props) => (
            <>
              <Can I="list" a="WhatsappCampaign">
                {() => <Invitations {...props} />}
              </Can>
              <Can not I="list" a="WhatsappCampaign">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="edit" a="WhatsappCampaign">
                {() => <Settings {...props} />}
              </Can>
              <Can not I="edit" a="WhatsappCampaign">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </WhatsappInvitationProvider>
  );
}

export default WhatsappCampaign;
